import Pagination from '@shared/Pagination/components/Pagination';

export { Pagination };
export default Pagination;
